import React, { useState, useEffect, useContext, memo } from "react";
import { Col, Form, FormGroup, Label } from "reactstrap";
import { formDataContext } from "../LoginPage";
import { Button, TextField, MessageAlert } from "../../../components/Components";
import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import "./Login.css";
import TextFieldPassword from "../../../components/TextFieldPassword/TextFieldPassword";

const Login = () => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const {
        username, setUsername,
        password, setPassword,
        isInValidUsername, setIsInValidUsername,
        isInValidPassword, setIsInValidPassword,
        lang,
        ResetPasswordClick,
        ValidateSignIn,
        HandleChangeLanguage
    } = useContext(formDataContext);

    const { t } = useTranslation();

    return (
        <>
            <div className="Login-container">
                <div style={{ textAlign: "end" }}>
                    <ToggleButtonGroup
                        size="small"
                        value={lang}
                        exclusive
                        onChange={HandleChangeLanguage}
                    >
                        <ToggleButton
                            value="th"
                            style={{
                                color: lang === "th" ? "#FFFFFF" : null,
                                backgroundColor: lang === "th" ? "#1C74D4" : null
                            }}
                        >
                            TH
                        </ToggleButton>
                        <ToggleButton
                            value="en"
                            style={{
                                color: lang === "en" ? "#FFFFFF" : null,
                                backgroundColor: lang === "en" ? "#1C74D4" : null
                            }}
                        >
                            EN
                        </ToggleButton>
                    </ToggleButtonGroup>
                </div>
                <div className="Login-detail">
                    <div className="Login-title">
                        <Label>{t('SignInToContractorManagement')}</Label>
                    </div>
                    <Label>{t('Username')}</Label>
                    <div
                        style={{ height: '60px', textAlign: 'end' }}
                    >
                        <TextField
                            placeholder={t('EnterUsername')}
                            required={isInValidUsername}
                            requiredText={t('PleaseEnterUsername')}
                            value={username}
                            onChange={(e) => {
                                setUsername(e.target.value);
                                setIsInValidUsername(false);
                            }}
                        />

                    </div>
                    {/* <div style={{ cursor: 'pointer', fontSize: '24px' }} onClick={togglePasswordVisibility}>
                        {showPassword ? (
                            <FaEye />
                        ) : (
                            <FaEyeSlash />
                        )}
                    </div> */}
                    <Label>{t('Password')}</Label>
                    <div>
                        <TextFieldPassword
                            placeholder={t('EnterPassword')}
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value);
                                setIsInValidPassword(false);
                            }}
                        />
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
                            <Label
                                style={{ cursor: 'pointer', fontSize: '14px' }}
                                onClick={ResetPasswordClick}
                            >
                                {t('ForgotPassword')}
                            </Label>
                            {
                                isInValidPassword &&
                                <Label style={{ fontSize: '12px', color: 'red' }}>
                                    {t('PleaseEnterPassword')}
                                </Label>
                            }
                        </div>
                    </div>
                    <div
                        style={{ textAlign: 'center' }}
                    >
                        <Button
                            title={t('SignIn')}
                            onClick={ValidateSignIn}
                            style={{ width: "200px", marginTop: "20px" }}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Login;